<template>
  <v-main class="favourites-view">
    <v-row>
      <v-col cols="12" v-if="$vuetify.display.mobile" class="crumb text-left mb-8 ml-1">
        <span @click="openMyAccount">{{ $t('user.my_account_btn') }}</span> / <span class="bold">{{ $t('page.favorite_profiles_name') }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" md="12" class="pa-0">
        <v-tabs
          background-color="secondary300"
          class="tabs ml-0 mt-0"
          v-model="selectedMaterial"
          :centered="$vuetify.display.mobile ? true : false"
        >
          <v-tab :class="['button text-none', $vuetify.display.mobile ? 'mobile' : '']" value="mtCell" >
            {{$t('results.favorite_donor_cell_profiles_tab_name')}} ({{getFavouritesCountByMaterialType('mtCell')}})
          </v-tab>
          <v-tab :class="['button text-none', $vuetify.display.mobile ? 'mobile' : '']" value="mtSemen" >
            {{$t('results.favorite_donor_semen_profiles_tab_name')}} ({{getFavouritesCountByMaterialType('mtSemen')}})
          </v-tab>
        </v-tabs>
        <div id="favourites-container" class="px-0 pb-4">
          
          <result-component :class="['mb-4', isLoading ? 'blur' : '']" v-for="(result, index) in results" :phenotypeData="result" :key="'r' + index" :disabled="result.max_true_reservation_count[0] < 1"/>

          <v-row class="my-9" v-if="!this.$vuetify.display.mobile && paginationLength && !isLoading">
            <v-col cols="9">
              <v-pagination
                v-model="page"
                color="primary"
                :length="paginationLength"
              ></v-pagination>
            </v-col>
            <v-col cols="2" class="px-0 text-right">
                <div class="results-page-size-label mt-3 pr-2">{{$t('results.per_page_label')}}:</div>
            </v-col>
            <v-col cols="1" class="pl-0 pr-3">
                <div class="float-left mt-1 mb-16 w-100">
                    <CustomSelect
                        v-model="selectedPageSize"
                        :multiple="false"
                        :flat="true"
                        size="small"
                        :chip="false"
                        :options="[{key: 5}, {key: 10}, {key: 20}, {key: 50}]"/>
                </div>
            </v-col>
          </v-row>
          <div class="info-wrapper">
            <div v-if="!isLoading && !selectedMaterialCount" :class="['info d-flex flex-column justify-center mt-4 mb-2 mx-4 py-12 px-9', $vuetify.display.mobile ? 'mobile' : 'text-left']">
              <div class="header mb-6 mb-md-4">
                {{$t('results.favorite_profiles_empty_header', {donors: $t(`donor.${selectedMaterial}.gen_plural`)})}}
              </div>
              <div class="subheader">
                {{$t('results.favorite_profiles_empty_subheader')}}
              </div>
            </div>
            <v-progress-circular
              v-if="isLoading"
              indeterminate
              color="primary"
              :size="50"
              :width="5"
            ></v-progress-circular>
          </div>
        </div>
        <v-chip
          v-if="this.$vuetify.display.mobile && results.length"
          class="results-chip" 
          size="x-small" 
          label 
          color="primary"
        >{{results.length}}/{{selectedMaterialCount}}</v-chip>
        <v-progress-linear
          v-if="this.$vuetify.display.mobile && results.length"
          :active="this.paginationLength > this.pageLoaded"
          indeterminate
          color="primary"
          v-intersect.quiet="loadNextPage"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import axios from "axios";
import { useStore, mapGetters, mapState } from "vuex";
import ResultComponent from '../components/ResultComponent.vue';
import CustomSelect from "../components/CustomSelectComponent";

export default {
  components: {
    ResultComponent,
    CustomSelect
  },
  data() {
    return {
      selectedMaterial: null,
      selectedPageSize: [],
      results: [],
      page: 1,
      isLoading: false,
      pageSize: 5,
      pageLoaded: 0,
      store: useStore(),
    }
  },
  computed: {
    ...mapGetters('favouritesModule', ['getCount','getFavouritesCountByMaterialType','getFavouritesProductKeysByMaterialType']),
    ...mapState('favouritesModule', ['currentMaterial']),
    selectedMaterialCount() {
      return this.getFavouritesCountByMaterialType(this.selectedMaterial)
    },
    paginationLength() {
      return Math.ceil(this.selectedMaterialCount / this.pageSize)
    },
  },
  created() {
    this.selectedMaterial = this.currentMaterial
    this.selectedPageSize = [{key: this.pageSize}]
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.want_to_be_a_parent',
      url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
      absolute: true
    },{
      name: 'breadcrumb.dashboard',
      url: '/dashboard?selected=personal-details'
    },
    {
      name: 'breadcrumb.dashboard_labels.favourites',
      url: ''
    }
    ])
  },
  watch: {
    selectedMaterial(m) {
      if (m) {
        this.page = 1
        this.pageLoaded = 0
        this.getFavouritesDonors()
        this.store.dispatch('favouritesModule/setCurrentMaterial', m)
        this.store.dispatch('compareModule/setContext',m);
      }
    },
    getCount() {
      this.page = 1
      this.getFavouritesDonors()
    },
    page(p) {
      this.getFavouritesDonors(p)
    },
    selectedPageSize(p) {
      this.pageSize = p[0].key
      this.getFavouritesDonors()
    }
  },
  methods: {
    getFavouritesDonors(page = 1, replaceResults = true) {
      if (this.selectedMaterialCount) {
        let favouritesProductKeys = this.getFavouritesProductKeysByMaterialType(this.selectedMaterial)
        if (replaceResults) {
          this.isLoading = true;
        }
        axios
          .post(`/api/donor/${this.selectedMaterial}/data`, {
            "from": ((page-1)*this.pageSize),
            "size": this.pageSize,
            "_source": true,
            "default_filters": false,
            "script_fields": [
              "age",
              "max_true_reservation_count"
            ],
            "filters": [
              {
                "type": "terms",
                "field": "id",
                "value": favouritesProductKeys
              }
            ]
          })
          .then((response) => {
            if (replaceResults) {
              this.results = response.data.data.map(e => ({...e._source, ...e.fields}))
            } else {
              response.data.data.map(e => ({...e._source, ...e.fields})).forEach((item) => this.results.push(item))
            }
          })
          .catch(err => {
            if (err.response) {
              console.error(err.response.data)
            }
          })
          .finally(() => {
            this.pageLoaded = page
            this.isLoading = false
          })
      } else {
        this.results = []
      }
    },
    loadNextPage(entries) {
      let nextPage = this.pageLoaded + 1
      if (entries && this.paginationLength > this.pageLoaded) {
        this.getFavouritesDonors(nextPage, false)
      }
    },
    openMyAccount() {
      this.$emit('openMyAccount', true);
    }
  }
}
</script>

<style lang="scss" scoped>
.blur {
  filter: blur(2px);
}
.results-chip {
  position: fixed;
  bottom: 8px;
  left: 8px;
}
.results-page-size-label {
  @include nsb-font-container;
  font-size: 14px;
}
.v-row {
  margin: 0px !important;
  padding: 0px !important;
}
.favourites-view {
  // background-color: rgb(252, 252, 255) !important;
}
:deep(#favourites-container) {
  // border: 1px solid $nsb-color-3;
  // background-color: $ds-white !important;
  // margin-top: 2px;
  .result-component {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}

.info-wrapper {
  position: relative;
  .v-progress-circular {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 999;
    transform: translate(-50%,-50%);
  }
  .info{
    height: 350px;
    .header {
      @include nsb-font-header-bold;
      font-size: 20px !important;
      line-height: 30px !important;
    }
    .subheader {
      @include nsb-font-header;
      font-size: 14px !important;
      line-height: 22px !important;
    }
    &.mobile {
      .header {
        font-size: 14px !important;
        line-height: 22px !important;
      }
      .subheader {
        font-size: 12px !important;
        line-height: 18px !important;
      }
    }
  }
}

.tabs {
  margin-bottom: -1px !important;
  .v-tab {
    color: $nsb-color-4 !important;
    font-size: 16px;
    line-height: 24px;
    padding-left: 32px;
    padding-right: 32px;

    // border: 1px solid $nsb-color-3;

    &:first-of-type {
      border-right: none !important;
    }
    &.v-tab--selected {
      background: white !important;
      color: $ds-primary !important;
      border: 1px solid $nsb-color-3;
      border-bottom: 1px solid white !important;

      :deep(.v-tab__slider) {
        display: none;
      }
    }
    &.mobile {
      font-size: 14px;
      line-height: 21px;
      padding-left: 16px;
      padding-right: 16px;
    }

    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
  }
  .button {
    @include nsb-font-button;
    font-size: 14px !important;
  }
}

:deep(.v-pagination__item) {
  margin-right: 0px;
  .v-btn {
    @include nsb-font-button-regular;
    font-size: 14px !important;
    line-height: 21px !important;
    max-height: 40px;
    max-width: 40px;
  }
  &.v-pagination__item--is-active {
    .v-btn {
      background-color: $ds-primary !important;
      color: $ds-white !important;
      .v-btn__overlay {
        opacity: 0;
      }
    }
  }
}
:deep(.v-pagination__prev) {
  margin-right: 8px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}
:deep(.v-pagination__next) {
  margin-left: 12px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}

.crumb {
  @include nsb-select-option;
  font-size: 12px;
  color: $ds-primary;
  .bold {
    @include nsb-select-chip;
    font-size: 12px;
    color: $ds-primary;
  }
}
@media (min-width: 960px) {
  .phenotype-view {
    margin-bottom: 200px;
  }
}
</style>
